import * as React from 'react';
import styles from './case-drafts-table.scss';

interface CaseDraftsTableHeaderProps {
  columns: string[];
  tableWidth?: number;
  columnWidths?: number[];
  containerRef?: React.RefObject<HTMLDivElement | null>;
  handleScroll: (event: React.UIEvent<HTMLDivElement, UIEvent>) => void;
}

export const CaseDraftsTableHeader = React.memo(({
  columns,
  tableWidth,
  columnWidths,
  containerRef,
  handleScroll
}: CaseDraftsTableHeaderProps) => {
  if (!columns?.length || !columnWidths?.length) {
    return null;
  }

  return (
    <div ref={containerRef} className={styles.headerContainer} onScroll={handleScroll}>
      <div className={styles.tableRow} style={{ width: tableWidth }}>
        {columns.map((label, index) => (
          <div key={index} className={styles.tableHead} style={{ width: columnWidths?.[index] }}>
            <div className={styles.header}>{label}</div>
          </div>
        ))}
        <div className={styles.contextMenuWrapper} />
      </div>
    </div>
  );
});
